<template>
  <!-- 中英文切换 -->
  <div class="zyqh">
    <img
      width="25px"
      src="/img/images/language/zh.png"
      v-if="$i18n.locale == 'en'"
      @click="switchLanguage('zh')"
    />
    <img
      width="25px"
      src="/img/images/language/en.png"
      v-if="$i18n.locale == 'zh'"
      @click="switchLanguage('en')"
    />
    <!-- <span @click="switchLanguage('zh')">简体中文 </span>
    |
    <span @click="switchLanguage('en')">English </span> -->
    <span @click="switchLanguage('zh')" v-if="$i18n.locale == 'en'"
      >简体中文
    </span>
    <span @click="switchLanguage('en')" v-if="$i18n.locale == 'zh'"
      >English
    </span>
  </div>
</template>

<script type="text/babel">
export default {
  name: "Languageqh",
  componentName: "Languageqh",
  computed: {},
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  methods: {
    // 语言切换
    switchLanguage(flg) {
      flg == "zh" ? (this.$i18n.locale = flg) : (this.$i18n.locale = "en");
      localStorage.setItem("language", flg);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.zyqh {
  display: flex;
  align-items: center;
  height: 20px;
  padding: 5px 20px 0px 0px;
  img {
    cursor: pointer;
  }
  span {
    cursor: pointer;
    font-size: 14px;
  }
}
</style>
